import Swiper from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";
import { getCSSVar } from "./helpers";

const initFeatureCardsSwiper = () => {
    const swiperContainer = document.querySelector(".feature-cards__inner");
    if (!swiperContainer) return;

    const navigationWrapper = document.querySelector(".feature-cards__navigation");

    let swiper;

    const updateNavigationVisibility = () => {
        if (!swiper || swiper.destroyed || !navigationWrapper) return;

        const totalSlides = swiper.slides.length;
        const perView = swiper.params.slidesPerView;
        const visibleSlides = typeof perView === "number" ? perView : 1;
        const isMultiplePages = totalSlides > visibleSlides;
        navigationWrapper.style.display = isMultiplePages ? "flex" : "none";
    };

    new ResizeObserver(() => {
        if (!swiper || swiper.destroyed) {
            swiper = new Swiper(swiperContainer, {
                slidesPerView: 1.2,
                spaceBetween: 20,
                modules: [Navigation, Pagination, A11y],
                navigation: {
                    nextEl: ".feature-cards__nav-next",
                    prevEl: ".feature-cards__nav-prev",
                },
                pagination: {
                    el: ".feature-cards__pagination",
                    type: "fraction",
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    [getCSSVar("--breakpoint-md", true)]: {
                        slidesPerView: 2,
                    },
                    [getCSSVar("--breakpoint-lg", true)]: {
                        slidesPerView: 3,
                    },
                    [getCSSVar("--breakpoint-xl", true)]: {
                        slidesPerView: 4,
                    },
                },
                on: {
                    init: updateNavigationVisibility,
                    resize: updateNavigationVisibility,
                    slideChange: updateNavigationVisibility,
                },
            });
        }
    }).observe(swiperContainer);
};

document.addEventListener("DOMContentLoaded", initFeatureCardsSwiper);
